<iframe 
	[src]="link | safe" 
	scrolling="no" frameborder="0" allowtransparency="true"
	[ngClass]="isForecast ? 'weather-big' : 'weather-small'">
</iframe>